import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class ActeComponentMini extends ShadowDOMElement {
	static className = "ActeComponentMini";
	
	render() {
    return html`
      <div>
        <title-field label="Acte"></title-field>
        <row-wrapper>
          <select-field
            id="nature-acte"
            label="Nature de l'acte *"
            value="0"
            required
            @change="${this.handleSelectChange}"
			name="id_act_nature"
          >
            <option-component label="Choisir" value="0"></option-component>
            <option-component label="Acte authentique" value="1"></option-component>
            <option-component label="Acte sous seing privé" value="2"></option-component>
          </select-field>
        </row-wrapper>

        <div id="acte-fields" style="display: none;">
          <row-with-tooltip
            tooltip-text="Indiquer uniquement la ville.">
            <text-field id="lieu-signature" label="Lieu de la signature" name="act_location"></text-field>
          </row-with-tooltip>
          <row-wrapper>
            <date-field id="date-acte" label="Date de l'acte" name="act_date"></date-field>
          </row-wrapper>
        </div>
      </div>
    `;
	}

	handleSelectChange (event) {
		const value = event.target.value;
		const fieldsContainer = this.shadowRoot.querySelector("#acte-fields");
		const inputFields = [
			"lieu-signature",
			"date-acte",
		].map((id) => this.shadowRoot.querySelector(`#${id}`));

		if (value === "0") {
			fieldsContainer.style.display = "none";
			inputFields.forEach((field) => {
				field.required = false;
				this.updateLabel(field, false);
			});
		} else {
			fieldsContainer.style.display = "block";
			const isRequired = value === "2";
			inputFields.forEach((field) => {
				field.required = isRequired;
				this.updateLabel(field, isRequired);
			});
		}
	}

	updateLabel(field, isRequired) {
		const label = field.getAttribute("label");
		if (isRequired) {
			if (!label.endsWith(" *")) {
				field.setAttribute("label", `${label} *`);
			}
		} else {
			field.setAttribute("label", label.replace(/ \*$/, ""));
		}
	}
	
	isTransient (){
		return false;
	}
}

customElements.define("acte-component-cession-mini", ActeComponentMini);
